import { render, staticRenderFns } from "./MaterialRecycleBin.vue?vue&type=template&id=ef7c5a66&scoped=true"
import script from "./MaterialRecycleBin.vue?vue&type=script&lang=js"
export * from "./MaterialRecycleBin.vue?vue&type=script&lang=js"
import style0 from "./MaterialRecycleBin.vue?vue&type=style&index=0&id=ef7c5a66&prod&lang=scss&scoped=true"
import style1 from "./MaterialRecycleBin.vue?vue&type=style&index=1&id=ef7c5a66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7c5a66",
  null
  
)

export default component.exports